var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTether(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon--tether",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#50AF95"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5994 13.3765C13.5101 13.3832 13.0485 13.411 12.0188 13.411C11.1997 13.411 10.6183 13.3862 10.4142 13.3765C7.24917 13.2359 4.88671 12.6797 4.88671 12.0138C4.88671 11.3479 7.24917 10.7925 10.4142 10.6497V12.8225C10.6212 12.8376 11.2139 12.8729 12.0329 12.8729C13.0157 12.8729 13.5078 12.8316 13.5965 12.8233V10.6512C16.7548 10.7933 19.1121 11.3494 19.1121 12.0138C19.1121 12.6782 16.7556 13.2344 13.5965 13.3757L13.5994 13.3765ZM13.5994 10.4265V8.48211H18.0072V5.51709H6.00651V8.48211H10.4135V10.4257C6.83147 10.5918 4.1377 11.3081 4.1377 12.1664C4.1377 13.0247 6.83147 13.7402 10.4135 13.9071V20.1378H13.5987V13.9048C17.1725 13.7387 19.8618 13.0232 19.8618 12.1657C19.8618 11.3081 17.1748 10.5926 13.5987 10.4257L13.5994 10.4265Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTether);
export default __webpack_public_path__ + "static/media/icon--tether.67660dcdb7e63a4794ecaa183b72895d.svg";
export { ForwardRef as ReactComponent };